import ActiveAccount from "./partials/ActiveAccount";
import SelectAccountModal from "../../Modals/SelectAccount/SelectAccountModal";
import SelectedAccountSidebar from "../../Modals/SelectAccount/SelectAccountSidebar";
import { FormatBalance, GetCurrenySymbol } from "../../../helper";
import ButtonCardType from "../partials/ButtonCardType";
import AdvancedChartWidget from "../../CryptoChart/AdvancedChartWidget";

const PrimaryCard = ({
  activeAccount,
  clientAccounts,
  crypto,
  type,
  theme,
  showChart = false,
}) => {
  return (
    <div className={`primary-card py-6 ${!showChart ? "max-h-[322px]" : ""}`}>
      <div className="md:block hidden">
        <SelectAccountModal
          activeAccount={activeAccount}
          clientAccounts={clientAccounts}
        >
          <ActiveAccount activeAccount={activeAccount} />
        </SelectAccountModal>
      </div>

      <div className="max-md:block hidden max-[360px]:max-w-[310px]">
        <SelectedAccountSidebar
          activeAccount={activeAccount}
          clientAccounts={clientAccounts}
          crypto={crypto}
        >
          <ActiveAccount activeAccount={activeAccount} />
        </SelectedAccountSidebar>
      </div>

      <div className="active-account-block flex-col justify-center items-center gap-1 inline-flex py-9">
        <div className="flex space-x-2 items-center justify-center font-medium text-[32px] leading-[48px] tracking-[0.16px]">
          <span>
            {activeAccount && GetCurrenySymbol(activeAccount.currency_code)}
          </span>
          <p className="flex items-center gap-3 max-md:text-2xl">
            {activeAccount &&
              FormatBalance(activeAccount.balance, activeAccount.is_crypto)}
          </p>
        </div>
        {!showChart && (
          <p className="text-base font-normal leading-normal tracking-tight">
            Account balance
          </p>
        )}
      </div>

      {showChart && theme && activeAccount && (
        <div className="w-full px-4 mb-6">
          <AdvancedChartWidget theme={theme} activeAccount={activeAccount} />
        </div>
      )}

      <div className="flex md:flex-nowrap flex-wrap items-center justify-between md:space-x-6 space-x-4">
        <ButtonCardType type={type} activeCard={activeAccount} />
      </div>
    </div>
  );
};

export default PrimaryCard;
